<template>
  <div class="main-grid">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="item in list"
      :key="item.id"
      class="news-item"
    >
      <div class="img-holder">
        <ImageContainer
          class="img"
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
        />
      </div>
      <div class="cat-wrapper">
        <div class="cat-meta">{{ item.sub_category.name }}</div>
      </div>
      <div class="meta-holder">
        <div class="title limited-text" style="--snup: 4">
          {{ item.title }}
        </div>
        <div class="date-wrapper">
          <span class="date">{{ handleDate(item.pub_date) }},</span>
          <span class="date" style="padding-left: 0.44em">{{
            handleTime(item.pub_date)
          }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FivthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-grid {
  position: relative;
  width: var(--width-content);
  display: grid;
  grid-template-areas:
    "elem-1 elem-1 elem-2"
    "elem-1 elem-1 elem-3"
    "elem-1 elem-1 elem-4"
    "elem-1 elem-1 elem-5"
    "elem-7 0 elem-6"
    "elem-8 elem-12 elem-12"
    "elem-9 elem-12 elem-12"
    "elem-10 elem-12 elem-12"
    "elem-11 elem-12 elem-12"
    "divider-bottom divider-bottom divider-bottom";
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 5rem;
  row-gap: 2.5rem;
  margin-bottom: 3em !important;

  .news-item {
    height: 8.4vw;
    position: relative;
    display: flex;
    color: var(--primary-font-color);

    &:first-child,
    &:last-child {
      display: flex;
      flex-direction: column;
      height: 100%;
      .img-holder {
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        height: 80%;
        margin-bottom: 1rem;

        .img {
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
      }

      .cat-wrapper {
        display: flex;
        transform: none;
      }

      .meta-holder {
        width: 100%;
        display: block;
        text-align: center;
        height: auto;
        flex: unset;
      }
    }

    &:first-child {
      grid-area: elem-1;
    }

    &:nth-child(2) {
      grid-area: elem-2;
    }
    &:nth-child(3) {
      grid-area: elem-3;
    }
    &:nth-child(4) {
      grid-area: elem-4;
    }
    &:nth-child(5) {
      grid-area: elem-5;
    }
    &:nth-child(6) {
      grid-area: elem-6;
    }
    &:nth-child(7) {
      grid-area: elem-7;
    }
    &:nth-child(8) {
      grid-area: elem-8;
    }
    &:nth-child(9) {
      grid-area: elem-9;
    }
    &:nth-child(10) {
      grid-area: elem-10;
    }
    &:nth-child(11) {
      grid-area: elem-11;
    }

    &:last-child {
      grid-area: elem-12;
    }

    .img {
      width: 8.4vw;
      height: 8.4vw;
      object-fit: cover;
      border-radius: 4px;
      margin-right: 1rem;
    }

    .cat-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      background-color: var(--background-color);
      font-family: Open Sans;
      transform: translateY(-48%);

      .cat-meta {
        &:first-child {
          font-weight: 600;
          text-transform: uppercase;
          padding: 2px 6px;
          padding-bottom: 3px;
        }
      }
    }

    .meta-holder {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1 0 0;

      .title {
        font-family: Roboto;
        font-size: 1.25em;
        font-weight: 500;
        line-height: 1.5em;
      }

      .date-wrapper {
        font-weight: 300;
        font-size: 0.875em;
        padding-top: 0.75em;
        opacity: 0.8;
        font-family: Open Sans;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .main-grid {
    grid-template-columns: auto auto;
    grid-template-areas:
      "elem-1 elem-1"
      "elem-2 elem-3"
      "elem-4 elem-5"
      "elem-6 elem-7"
      "elem-8 elem-9"
      "elem-10 elem-11"
      "elem-12 elem-12";
    column-gap: 4rem;
    row-gap: 2rem;
    .news-item {
      &:first-child,
      &:last-child {
        .img-holder {
          border-radius: 4px;
          position: relative;
          padding-top: 56.25%; /* 16:9 Aspect Ratio */
          overflow: hidden;

          .img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
}

@media (min-width: 375px) and (max-width: 768px) {
  .main-grid {
    grid-template-areas:
      "elem-1 elem-1"
      "elem-2 elem-3"
      "elem-4 elem-5"
      "elem-6 elem-7"
      "elem-8 elem-9"
      "elem-10 elem-11"
      "elem-12 elem-12";
    grid-template-columns: auto auto;
    column-gap: 3rem;
    row-gap: 2.5rem;
    width: 100% !important;
    .news-item {
      height: 150px;
      margin-left: 10px !important;

      .img-holder {
        border-radius: 4px;
        position: relative;
        padding-top: 56.25%; /* 16:9 Aspect Ratio */
        overflow: hidden;

        .img {
          display: none;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      .meta-holder {
        text-align: start;
        margin-top: 20px;
      }

      &:nth-child(1),
      &:nth-child(12) {
        height: auto;
        margin-left: 0 !important;

        .img {
          display: block;
        }

        .meta-holder {
          margin-top: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .main-grid {
    grid-template-areas:
      "elem-1 elem-2"
      "elem-3 elem-3"
      "elem-4 elem-5"
      "elem-6 elem-7"
      "elem-8 elem-9"
      "elem-10 elem-10"
      "elem-11 elem-12";
    grid-template-columns: auto auto;
    column-gap: 0rem;
    row-gap: 2.5rem;
    width: 100% !important;
    .news-item {
      flex-direction: column;
      height: auto;
      .meta-holder {
        text-align: start;
        height: auto;
        margin-top: 10px;
      }
      .img {
        display: none;
      }

      &:nth-child(12) {
        .date-wrapper {
          width: 140px;
          text-align: start;
        }
        .title {
          width: 150px;
          text-align: start;
        }
        .cat-wrapper {
          position: absolute;
          left: 0;
          top: -12px;
        }
      }
      &:nth-child(3) {
        .date-wrapper {
          text-align: center;
        }
      }

      &:nth-child(12),
      &:nth-child(11),
      &:nth-child(7),
      &:nth-child(6),
      &:nth-child(5),
      &:nth-child(4) {
        margin-top: 10px;
        margin-left: 5px;

        .title {
          width: 140px;
        }
        .cat-wrapper {
          top: -8px;
        }
      }

      &:nth-child(12) {
        .cat-wrapper {
          top: -18px;
        }
      }
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(8),
      &:nth-child(9) {
        .img-holder {
          padding-top: 0;
          border-radius: 0;
          margin-bottom: 0;

          .img {
            position: relative;
            display: block;
            width: 100% !important;
            border-radius: 0;
            height: 128px;
            margin-right: 0rem;
            margin-bottom: 0rem;
          }
        }
        .meta-holder {
          text-align: start;
          margin-left: 0.35rem;
        }
      }

      &:nth-child(3),
      &:nth-child(10) {
        display: block;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1rem;

        .img-holder {
          position: relative;
          padding-top: 56.25%; /* 16:9 Aspect Ratio */

          .img {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            width: 100%;
            height: 100%;
          }
        }

        .title,
        .date-wrapper {
          text-align: center;
        }

        .meta-holder {
          text-align: start;
        }
      }

      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(8),
      &:nth-child(9),
      &:nth-child(10) {
        .cat-wrapper {
          top: 10px;
        }
      }

      &:last-child {
        .img-holder {
          display: none;
          padding-top: 0;
        }
      }
    }
  }
}
</style>
